import Header from '@propertypal/shared/src/resources/images/pn-devs/millmount-village/header.png';
import React, { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { Text, TextProps } from '../../typography';
import DevelopmentContent, { DevelopmentSection } from './DevelopmentContent.pn';
import { DevHeaderImg, DevUnorderdList } from './DevelopmentContent.style.pn';

interface MillmountVillageContentProps {}

const MillmountVillageContent: React.FC<MillmountVillageContentProps> = () => {
  const theme = useTheme();

  const textProps = useMemo(() => {
    const p: TextProps = {
      fontSize: 17,
      lineHeight: 25,
      mt: 8,
      mb: 16,
      color: theme.textDark,
    };
    return p;
  }, [theme]);

  return (
    <div data-testid="millmount-village-content">
      <DevelopmentContent bg="#f6f7f8">
        <DevelopmentSection narrow>
          <DevHeaderImg src={Header.src} alt="Millmount Village Development" />
          <DevUnorderdList {...textProps}>
            <li>Show Home Available to View By Private Appointment, Please Contact The Selling Agents</li>
            <li>SPECIFICATION</li>
            <li>INTERNAL FEATURES</li>
            <li>Internal walls and ceilings painted along with the internal woodwork</li>
            <li>Moulded skirting and architrave</li>
            <li>Panelled internal doors with quality ironmongery</li>
            <li>Smoke, heat and carbon monoxide detectors</li>
            <li>
              Comprehensive range of electrical sockets with USB connections fitted to the kitchen and master bedroom
            </li>
            <li>TV/Data connections to lounge, kitchen/dining and all bedrooms</li>
            <li>
              TV/satellite co-axial cable terminated at external location and distributed via a central hub located in
              the store leaving your TV cabling for your TV installer to connect for whichever option you choose
            </li>
            <li>Additional cable left in roofspace for connection of digital TV aerial by your TV installer</li>
            <li>
              Hardwired using Cat 6 cable to all TV points Cat 6 is capable of transmitting various signals such as
              data/ satellite/HDMI, and due to the variety of systems/ options available we have left the final
              connections in the store to be completed by the homeowner&apos;s own installer according to their own
              requirements
            </li>
            <li>Thermostatically controlled radiators</li>
            <li>Energy efficient LED downlighting to kitchen, bathroom and en-suite (where applicable)</li>
            <li>Zoned security alarm</li>
            <li>KITCHEN</li>
            <li>Choice of kitchen doors, handles, worktop colours with co-ordinating upstand and splashback to hob</li>
            <li>
              Integrated electrical appliances to include gas hob and electric oven, extractor unit, fridge/freezer,
              dishwasher and washer/dryer If there is a utility room, washer/dryer will be freestanding
            </li>
            <li>BATHROOM, ENSUITE (WHERE APPLICABLE) &amp; WC</li>
            <li>Contemporary designer white sanitary ware with chrome fittings</li>
            <li>Thermostatically controlled shower overbath in bathroom with screen door</li>
            <li>Thermostatically controlled shower in ensuite</li>
            <li>Chrome heated towel rail in bathroom and ensuite</li>
            <li>Full height tiling to shower enclosures</li>
            <li>Where shower/bath is fitted the enclosure walls will be fully tiled</li>
            <li>Splash back tile to bathroom, ensuiteand downstairs cloakroom basins</li>
            <li>FLOORING</li>
            <li>Lounge, bedrooms, stairs and landing carpeted</li>
            <li>Hall, kitchen/dining, ground floor cloakroom, bathroom and ensuite floors tiled</li>
            <li>Tiled floor to sun room where applicable</li>
            <li>EXTERNAL FEATURES</li>
            <li>High standard of floor, wall and loft insulation to ensure minimal heat loss</li>
            <li>Mouldings to door and window surrounds to selected house designs</li>
            <li>Maintenance free uPVC energy efficient double glazing with lockable system(where appropriate)</li>
            <li>Bitmac driveways</li>
            <li>Coloured prefinished insulated composite front door</li>
            <li>Rear gardens topsoiled</li>
            <li>Front gardens landscaped in keeping with the rest of the development</li>
            <li>Extensive landscaping to common areas</li>
            <li>Timber fencing and walling to boundaries (where appropriate)</li>
            <li>Feature external lighting to front door</li>
            <li>Outside tap</li>
            <li>HEATING</li>
            <li>
              Gas fired central heating energy efficient combination boiler which provides instant hot water on demand
            </li>
            <li>Zoned heating with time clock in line with building control regulations</li>
            <li>SELECTIONS</li>
            <li>All selections to be made from the builder&apos;s nominated suppliers only</li>
            <li>All selections are from a pre-selected rangeand are subject to stage of construction</li>
            <li>WARRANTY</li>
            <li>White goods carry a 1 year guarantee from date of installation</li>
            <li>NHBC 10 year buildmark warranty</li>
          </DevUnorderdList>
          <Text {...textProps}>
            Please contact the selling agents for further information. Ideally Located Situated just off the Comber
            Road, Millmount Village boasts a large collection of detached and semi-detached homes, all designed and
            finished to a turnkey specification. Characterised by open and modern interiors with a driveway and garden,
            no detail has been overlooked in the quest to ensure that these new homes lend themselves to easy
            maintenance and practical family living. With excellent public transport and cycle links into Belfast City
            Centre, and within close proximity to George Best City Airport, Millmount Village is ideally located for
            those making the daily commute. These homes would be perfect for young professionals or growing families who
            want the full package - a tight-knit community feel, with an abundance of amenities and outdoor spaces just
            minutes from your front door. All on your Doorstep Tucked away in one of the most sought-after residential
            areas of East Belfast, Millmount Village is a great place to call home. Not only are Comber Road and
            Dundonald Village home to a variety of cafés, restaurants, convenience stores, independently-run shops,
            schools, and recreational facilities, the much-loved bohemian area of Ballyhackamore has become a must-see,
            with it&apos;s lively art scene and award-winning eateries. Owners of a home in Millmount Village are also
            at the gateway to some of the most breath-taking scenery and green spaces the country has to offer. Take the
            opportunity to enjoy a tranquil cycle along the treasured Comber Greenway, meander through the picturesque
            grounds of Stormont Estate, or admire the incredible views over Strangford Lough from Scrabo Tower.
            Something Very Special It goes without saying that Millmount Village offers homeowners something truly
            special, both inside and out. From the lush fairways of Shandon and Belvoir Golf Clubs to the renowned
            Titanic Belfast and CS Lewis Square, you&apos;d be hard pushed to find a location better than this one.
            What&apos;s more, Streamvale Open Farm, Dundonald Ice Bowl and East Point Entertainment Village are family
            favourites for keeping the kids amused. Design and Architecture Millmount Village has been designed by Alan
            Patterson Design, one of the foremost architectural practices in Ireland. Under the skilful guidance of
            founding parter, Alan Patterson, this design team has nurtured an enviable reputation for producing a
            consistently fresh and individual approach to its work and this is reflected in every project, no less so
            than in Millmount Village. Why choose a Lagan Home? Lagan Homes has been building outstanding homes for over
            30 years. In that time it has provided thousands of people with homes they love and that suits their
            lifestyle. They are desirable homes because of their designs and how they are made to enhance how one lives.
            ENVIRONMENTAL Our new homes are energy-efficient with high levels of insulation thereby reducing heat loss
            and your fuel bills. They achieve energy-efficiency ratings far in excess of the average for Northern
            Ireland. SAFETY &amp; SECURITY Double glazing, window locks, 3 point locking system to main doors, smoke,
            heat and carbon monoxide detectors and security alarms are installed throughout giving home owners peace of
            mind and potentially lower insurance premiums. (window locks - excluding emergency escape windows). NEW HOME
            WARRANTY A 10 year Buildmark warranty will be available for all homes at Millmount Village from NHBC which
            is responsible for setting the standards of the house-building industry. YOUR NEW HOME Owners have the
            satisfaction of knowing that Millmount Village represents a team effort involving the dedication, commitment
            and expertise of our finest architects and craftsmen. Owners will also benefit from a full turnkey finish.
          </Text>
        </DevelopmentSection>
      </DevelopmentContent>
    </div>
  );
};

export default MillmountVillageContent;
